import anime from 'animejs';
import imagesLoaded from 'imagesloaded';

const mobileMql = window.matchMedia(`(max-width: 414px)`);

function isMobileScreen() {
	return mobileMql.matches;
}

export default class MainVisual {
	constructor() {
		if (document.querySelector('.js-home-mv') === null) return;
		this.timeline = anime.timeline();
		this.bg = document.querySelector('.js-mv-bg');
		this.truck = document.querySelector('.js-mv-truck');
		this.operators = document.querySelector('.js-mv-operators');
		this.fukidashi = document.querySelector('.js-mv-fukidashi');
		this.line1 = document.querySelector('.js-mv-statement-line1');
		this.line2 = document.querySelector('.js-mv-statement-line2');
		this.line3 = document.querySelector('.js-mv-statement-line3');
		this.line4 = document.querySelector('.js-mv-statement-line4');

		this.init();
		this.bindEvents();
	}

	bindEvents() {
		imagesLoaded([
			this.bg,
			this.truck,
			this.operators,
			this.fukidashi,
			this.line1,
			this.line2,
			this.line3,
			this.line4
		], { background: true }, () => {
			this.startTimeLine();
		})
	}

	startTimeLine() {
		this.timeline.play();
	}

	init () {
		this.timeline.add({
			targets: this.truck,
			translateX: isMobileScreen() ? '108px' : '132px',
			left: 0,
			delay: 1000,
			duration: 2000,
			easing: isMobileScreen() ? 'cubicBezier(0.370, 0.120, 0.410, 0.875)' : 'cubicBezier(0.185, 0.230, 0.185, 0.975)',
		}).add({
			targets: this.operators,
			opacity: 1,
			rotate: [
				{
					value: -15,
					duration: 500,
					elasticity: 0
				},
				{
					value: 0,
					duration: 500,
					elasticity: 0
				},
				{
					value: -15,
					duration: 500,
					elasticity: 0
				},
				{
					value: 0,
					duration: 500,
					elasticity: 0
				}
			],
			delay: 400,
		}).add({
			targets: this.fukidashi,
			duration: 700,
			easing: 'easeInCubic',
			opacity: 1
		}, '-=200').add({
			targets: this.line1,
			duration: 700,
			easing: 'easeInCubic',
			opacity: 1
		}, '-=600').add({
			targets: this.line2,
			duration: 1000,
			easing: 'easeInCubic',
			opacity: 1
		}, '-=600').add({
			targets: this.line3,
			duration: 1000,
			easing: 'easeInCubic',
			opacity: 1
		}, '-=600').add({
			targets:this.line4,
			duration: 1000,
			easing: 'easeInCubic',
			opacity: 1
		}, '-=600').pause();

	}
}
